import FeatureGates from '@atlaskit/feature-gate-js-client';
import { extensionUrl } from '../config/config';
import { STATSIG_FEATURE_GATES } from '../bootstrap/statsigFeatureGates';

// TODO ASIMO-232 fix this type to use the actual message type when commons is implemented
interface WindowMessage {
	type: string;
	[key: string]: any;
}

export function postMessageToParent(message: WindowMessage): void {
	const isSafePostWindowEnabled = FeatureGates.checkGate(STATSIG_FEATURE_GATES.SAFE_POST_WINDOW);

	if (isSafePostWindowEnabled) {
		window.parent.postMessage(message, extensionUrl);
	} else {
		window.parent.postMessage(message, '*');
	}
}

export function requestDomContext(): void {
	postMessageToParent({
		type: 'REQUEST_DOM_CONTEXT',
		payload: {
			getDomContext: true,
		},
	});
}
